import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const mapWarehouseWithStore = (brandId, data) => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/warehouse/api/v1/brand/' + brandId + '/ware-house-store',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateMapWarehouseWithStore = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/warehouse/api/v1/brand/' +
      brandId +
      '/ware-house-store',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getWarehouseStore = brandId => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/warehouse/api/v1/brand/' + brandId + '/ware-house-store',
    headers: getHeaders(),
  });
};

export const getWarehouseStoreById = warehouseId => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/warehouse/api/secure/v1/ware-house/' + warehouseId + '/store',
    headers: getHeaders(),
  });
};
